import arEG from '../../.octopus/ar-EG/index.js';

export default {
  TntdNewReference: arEG,
};
